import { useState, useEffect, useCallback, MutableRefObject } from 'react';

export const IS_IOS_WEBKIT =
    typeof document !== 'undefined' &&
    // @ts-ignore
    !!document.createElement('video').webkitEnterFullscreen &&
    // @ts-ignore
    !document.createElement('video').webkitRequestFullscreen &&
    !document.createElement('video').requestFullscreen;

const IS_WEBKIT =
    typeof document !== 'undefined' && typeof document.fullscreenElement === 'undefined';

const FULLSCREENCHANGE = IS_WEBKIT ? 'webkitfullscreenchange' : 'fullscreenchange';

const REQUEST_FULLSCREEN =
    (IS_IOS_WEBKIT && 'webkitEnterFullscreen') ||
    (IS_WEBKIT && 'webkitRequestFullscreen') ||
    'requestFullscreen';

const EXIT_FULLSCREEN = IS_WEBKIT || IS_IOS_WEBKIT ? 'webkitExitFullscreen' : 'exitFullscreen';

const FULLSCREEN_ELEMENT = IS_WEBKIT ? 'webkitFullscreenElement' : 'fullscreenElement';

export const useFullscreen = (
    elementRef: MutableRefObject<HTMLElement | null>,
    blurOnFullscreen?: boolean,
    onFullscreenOpen?: () => void,
    onFullScreenClose?: () => void
): {
    isFullscreen: boolean;
    handleFullscreenToggle: () => void;
} => {
    const [isFullscreen, setIsFullscreen] = useState(false);

    const handleFullscreenToggle = async (): Promise<void> => {
        if (!isFullscreen) {
            // @ts-ignore
            elementRef.current[REQUEST_FULLSCREEN]?.();
            if (onFullscreenOpen) {
                onFullscreenOpen();
            }
        } else {
            // @ts-ignore
            document[EXIT_FULLSCREEN]();
            if (onFullScreenClose) {
                onFullScreenClose();
            }
        }
    };

    // handle change with event listener because the only certain way to ascertain
    // fullscreen state is with events or by querying document state.
    const handleFullscreenChange = useCallback(() => {
        // @ts-ignore
        if (document[FULLSCREEN_ELEMENT]) {
            // if fullscreenElement is truthy then event is enter fullscreen
            setIsFullscreen(true);
            if (blurOnFullscreen) {
                // @ts-ignore
                document.activeElement?.blur();
            }
        } else {
            // if fullscreenElement is null then event is exit fullscreen
            setIsFullscreen(false);
        }
    }, [blurOnFullscreen]);

    useEffect(() => {
        document.addEventListener(FULLSCREENCHANGE, handleFullscreenChange);
        return () => {
            document.removeEventListener(FULLSCREENCHANGE, handleFullscreenChange);
        };
    }, [handleFullscreenChange]);
    return { isFullscreen, handleFullscreenToggle };
};
